module.exports = __webpack_public_path__ + "static/media/L4-CSS3.3f2e0e4c.svg";